// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section id='customer-loans-check-payment' class="box">
  <sub-header header="'Check payment'"></sub-header>

    <form name="\$ctrl.form">
      <form-section>
        <amortization-payment
          loan="\$ctrl.loan"
          payment-request="\$ctrl.paymentRequest"
          collect-official-receipt="true"
          custom-payment-allowed="\$ctrl.canPerformCustomPayment"
          allow-overpayment="true">
        </amortization-payment>
      </form-section>

      <check-form
        class="no-print"
        check-model="\$ctrl.checkModel"
        product-id="\$ctrl.loanId"
        entry-type="'CREDIT'"
        disable-amount-input="true"
        on-us-check-allowed="true">
      </check-form>

      <div class="buttons">
        <button type="button" class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
        <button type="button" class="btn btn-primary" ng-click="\$ctrl.print()">Print</button>
        <button type="button" class="btn btn-print" ng-click="\$ctrl.pay()"
                ng-disabled="\$ctrl.form.\$invalid || !\$ctrl.loan">
          Confirm payment
        </button>
      </div>

      <div class="clearfix"></div>
    </form>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/check-payment/loan-check-payment.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;